var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4784_84148)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 29,
    height: 29,
    rx: 5,
    fill: "#43AC43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15C18.6326 15 18.7598 15.0527 18.8536 15.1464C18.9473 15.2402 19 15.3674 19 15.5V17H20.5C20.6326 17 20.7598 17.0527 20.8536 17.1464C20.9473 17.2402 21 17.3674 21 17.5C21 17.6326 20.9473 17.7598 20.8536 17.8536C20.7598 17.9473 20.6326 18 20.5 18H19V19.5C19 19.6326 18.9473 19.7598 18.8536 19.8536C18.7598 19.9473 18.6326 20 18.5 20C18.3674 20 18.2402 19.9473 18.1464 19.8536C18.0527 19.7598 18 19.6326 18 19.5V18H16.5C16.3674 18 16.2402 17.9473 16.1464 17.8536C16.0527 17.7598 16 17.6326 16 17.5C16 17.3674 16.0527 17.2402 16.1464 17.1464C16.2402 17.0527 16.3674 17 16.5 17H18V15.5C18 15.3674 18.0527 15.2402 18.1464 15.1464C18.2402 15.0527 18.3674 15 18.5 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.5V23C24 23.5304 23.7893 24.0391 23.4142 24.4142C23.0391 24.7893 22.5304 25 22 25H14C13.4696 25 12.9609 24.7893 12.5858 24.4142C12.2107 24.0391 12 23.5304 12 23V11C12 10.4696 12.2107 9.96086 12.5858 9.58579C12.9609 9.21071 13.4696 9 14 9H19.5L24 13.5ZM21 13.5C20.6022 13.5 20.2206 13.342 19.9393 13.0607C19.658 12.7794 19.5 12.3978 19.5 12V10H14C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V23C13 23.2652 13.1054 23.5196 13.2929 23.7071C13.4804 23.8946 13.7348 24 14 24H22C22.2652 24 22.5196 23.8946 22.7071 23.7071C22.8946 23.5196 23 23.2652 23 23V13.5H21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4784_84148",
    x: 0,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4784_84148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4784_84148",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramActionIcon);
export default __webpack_public_path__ + "static/media/program-action-icon.3448e1f282324d64d0e5f940f83c03be.svg";
export { ForwardRef as ReactComponent };